import { render } from "./icons-arrow-right.svg?vue&type=template&id=bbfa51c4?inline"
const script = {}
script.render = render

export default script